import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

import * as types from '../actionTypes';
import type { BrandingTemplate, FetchBrandingTemplatesSuccessAction } from '../types';

const brandingTemplateAdapter = createEntityAdapter<BrandingTemplate>({ selectId: ({ id }) => id });

export const initialState = brandingTemplateAdapter.getInitialState();

type State = typeof initialState;

const handleFetchBrandingTemplatesSuccess = (state: State, action: FetchBrandingTemplatesSuccessAction) =>
  brandingTemplateAdapter.setAll(state, action.payload.content);

export default createReducer(initialState, {
  [types.FETCH_BRANDING_TEMPLATES_SUCCESS]: handleFetchBrandingTemplatesSuccess,
});
